import { Calendar } from "primereact/calendar";
import { CSSProperties, FC } from "react";
import "./SimpleCalendar.css";
import cross from "../../../assets/cancelGreey.svg";

interface ICalendarProps {
    date: Date | undefined;
    onChange?: (date: Date | undefined) => void;
    showResetButton?: boolean;
    onReset?: () => void;
    placeholder?: string;
    baseZIndex?: number;
    className?: string;
    style?: CSSProperties;
}

const SimpleCalendar: FC<ICalendarProps> = ({
    date,
    onChange,
    showResetButton,
    onReset,
    className,
    style,
    placeholder,
    baseZIndex
}) => {
    return (
        <div className={`simple-calendar ${className}`} style={style}>
            <Calendar
                placeholder={placeholder}
                value={date}
                baseZIndex={baseZIndex}
                onChange={(e) => {
                    if (onChange) onChange(e.value ?? undefined);
                }}
                selectionMode="single"
                readOnlyInput
                hideOnDateTimeSelect
                dateFormat="dd.mm.yy"
            />
            {showResetButton ? (
                <img
                    alt="cross"
                    className="simple-calendar-reset-button"
                    src={cross}
                    onClick={() => {
                        if (onReset) onReset();
                    }}
                />
            ) : null}
        </div>
    );
};

export default SimpleCalendar;
